export const SINGLE_ACCOUNT_SIGNAL_OUTBOUND_COLOR = 'brand.forest';
export const SINGLE_ACCOUNT_SIGNAL_INBOUND_COLOR = 'brand.denim';
